import * as React from 'react';

import Popover from 'components/popover/Popover';

import { __t, applyTranslations } from 'utils/language';

import './profile-fashion-sizes-popover.scss';

applyTranslations(require('./profile-fashion-sizes-popover.i18n.json'));

const MSG_KEY = 'profile_fashion_sizes_popover';

const ProfileFashionSizesPopover = (): JSX.Element => {
  const renderPopover = (): React.ReactNode => {
    const getText = (key: string): React.ReactNode => (
      <div>
        <strong>
          {__t(`${MSG_KEY}.${key}`)}
        </strong>:&nbsp;
        <span>
          {__t(`${MSG_KEY}.${key}_text`)}
        </span>
      </div>
    );

    return (
      <Popover
        classNameWrapper="profile-fashion-sizes-popover__popover-wrapper"
        classNamePopover="profile-fashion-sizes-popover__popover"
        showQuestionMark
      >
        <div className="profile-fashion-sizes-popover__body">
          {getText('adaptive')}
          {getText('petite')}
          {getText('plus_size')}
          {getText('standard_manufacturer_sizing')}
          {getText('tall')}
        </div>
      </Popover>
    );
  };

  return (
    <div className="profile-fashion-sizes-popover">
      {renderPopover()}
    </div>
  );
};

export default ProfileFashionSizesPopover;
